/* vcz-promo.js — Promo escalonada (VCZ)
   Mantém as tags (cabeçalho + carrinho) e o bloco da página de produto em sincronia com o carrinho.
   Não calcula nada por conta própria: sections/api-cart-items.liquid renderiza as tags no servidor
   a cada alteração; vcz-cart.js dispara `vcz:cart:built` com esse conteúdo e aqui copiamos o HTML
   para todos os [data-vcz-promo-slot] e atualizamos o rodapé/linha realçada do bloco de marcos
   a partir do data-count das tags. */
(function () {
  'use strict';

  function fill(tpl, n, tot) {
    return (tpl || '').replace('[n]', n).replace('[tot]', tot);
  }

  function itemsLabel(block, n) {
    if (n === 1) return block.dataset.itemOne || '1 item';
    return (block.dataset.itemMany || '[n] items').replace('[n]', n);
  }

  function updateTiers(count) {
    document.querySelectorAll('[data-vcz-tiers]').forEach(function (block) {
      var q1 = Number(block.dataset.q1) || 2;
      var q2 = Number(block.dataset.q2) || 3;
      var after = count + 1;
      var on = after >= q2 ? 2 : (after >= q1 ? 1 : 0);
      block.querySelectorAll('[data-vcz-tile]').forEach(function (t) {
        t.classList.toggle('is-on', Number(t.dataset.vczTile) === on);
      });
      var foot = block.querySelector('[data-vcz-tiers-foot]');
      if (!foot) return;
      var txt;
      if (count === 0) txt = block.dataset.st0;
      else if (count >= q2) txt = block.dataset.st3;
      else if (after >= q2) txt = fill(block.dataset.st2, itemsLabel(block, count), itemsLabel(block, after));
      else if (after >= q1) txt = fill(block.dataset.st1, itemsLabel(block, count), itemsLabel(block, after));
      else txt = block.dataset.st0;
      foot.textContent = txt || '';
    });
  }

  /* Animação de enchimento (classe .vcz-anim, ver vcz-promo.css). Reinicia-se a cada chamada. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animate(scope) {
    if (reduceMotion) return;
    (scope || document).querySelectorAll('[data-vcz-promo-tags]').forEach(function (t) {
      t.classList.remove('vcz-anim');
      void t.offsetWidth;   // força reflow para a animação recomeçar
      t.classList.add('vcz-anim');
    });
  }

  function sync(content) {
    var src = content && content.querySelector('[data-api-vcz-promo]');
    if (!src) return;
    document.querySelectorAll('[data-vcz-promo-slot]').forEach(function (slot) {
      slot.innerHTML = src.innerHTML;
    });
    var tags = src.querySelector('[data-vcz-promo-tags]');
    if (tags) updateTiers(Number(tags.dataset.count) || 0);
    animate(document);
  }

  /* 1) ao carregar a página */
  animate(document);
  /* 2) sempre que o carrinho abre (o Broadcast põe .is-open no <cart-drawer>) */
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && 'MutationObserver' in window) {
    var wasOpen = cartDrawer.classList.contains('is-open');
    new MutationObserver(function () {
      var open = cartDrawer.classList.contains('is-open');
      if (open && !wasOpen) animate(cartDrawer);
      wasOpen = open;
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* Página de produto: o script do tema re-renderiza [data-vcn-price-wrapper] ao trocar de variante
     e o selo desaparece. Guardamos uma cópia e repomo-lo com o preço da variante atual. */
  (function () {
    var wrap = document.querySelector('[data-vcn-price-wrapper]');
    var badge = wrap && wrap.querySelector('[data-vcz-badge]');
    if (!wrap || !badge) return;
    var tpl = badge.dataset.tpl || '[price] with [q] items';
    var pct = Number(badge.dataset.pct) || 0, q = badge.dataset.q || '3', roundUp = badge.dataset.round === '1';
    var keep = badge.cloneNode(true);
    function money(sample, value) {
      // reutiliza o formato do preço atual (ex.: "€59" ou "59,00 €") trocando só o número
      var num = roundUp ? String(value) : value.toFixed(2).replace('.', sample.indexOf(',') > -1 ? ',' : '.');
      return sample.replace(/\d[\d.,]*/, num);
    }
    function restore() {
      if (wrap.querySelector('[data-vcz-badge]')) return;
      var cur = wrap.querySelector('[data-vcn-current-price]');
      var sample = cur ? cur.textContent.trim() : '';
      var raw = sample.replace(/[^\d.,]/g, '').replace(',', '.');
      var price = parseFloat(raw);
      var el = keep.cloneNode(true);
      if (sample && !isNaN(price)) {
        var v = price * (100 - pct) / 100;
        v = roundUp ? Math.ceil(v) : Math.round(v * 100) / 100;
        el.textContent = tpl.replace('[price]', money(sample, v)).replace('[q]', q);
      }
      wrap.appendChild(el);
    }
    new MutationObserver(function () { restore(); }).observe(wrap, { childList: true, subtree: true });
  })();

  document.addEventListener('vcz:cart:built', function (e) {
    sync(e.detail && e.detail.content);
  });

  // Fallback: se o carrinho mudar sem passar pelo build (ex.: página de carrinho), pede o parcial.
  var pending = null;
  function refetch() {
    if (pending) return;
    pending = fetch(window.theme && window.theme.routes && window.theme.routes.root
      ? window.theme.routes.root.replace(/\/$/, '') + '/?section_id=api-cart-items'
      : '/?section_id=api-cart-items', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        sync(doc);
      })
      .catch(function () {})
      .finally(function () { pending = null; });
  }
  document.addEventListener('theme:cart:change', function () {
    if (!document.querySelector('cart-items')) refetch();
  });

  /* Total da encomenda no botão de checkout: copia o valor escondido que cart-price.liquid
     renderiza ([data-vcz-checkout-total]) para o span do botão, sempre que o bloco de preços
     do drawer é re-renderizado pelo tema. */
  function syncCheckoutTotal() {
    var src = document.querySelector('[data-vcz-checkout-total]');
    var txt = src ? src.textContent.trim() : '';
    document.querySelectorAll('[data-vcz-checkout-total-out]').forEach(function (out) {
      out.textContent = txt;
      out.hidden = !txt;
    });
  }
  syncCheckoutTotal();
  var priceHolder = document.querySelector('[data-cart-price-holder]');
  if (priceHolder && 'MutationObserver' in window) {
    new MutationObserver(syncCheckoutTotal).observe(priceHolder, { childList: true, subtree: true });
  }
  document.addEventListener('theme:cart:change', function () { setTimeout(syncCheckoutTotal, 400); });
  document.addEventListener('vcz:cart:built', function () { setTimeout(syncCheckoutTotal, 50); });
})();
